import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_58: FaireProductEntity = {
  token: "catalog_prod_prod-58",
  type: "product",
  name: "Teak Root Sculpture on Stand - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop",
  priceDollars: 30.3,
  msrpDollars: 75.75,
  sku: "JA0058",
  caseSize: 2,
  material: "Metal",
  collectionToken: "col_japandi",
  categoryTokens: ["catalog_cat_dogs"],
  isNew: true,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 98,
  description: "Beautiful Japandi piece perfect for any home.",
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
